/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyBatchResponse {
    getFixupPrototypeFunction() { return PolicyBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<PolicyBatchResponse>): PolicyBatchResponse {
        let obj = Object.assign(new PolicyBatchResponse(), model);
        PolicyBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyBatchResponse>): PolicyBatchResponse {
        if (!model) return null;
        return PolicyBatchResponse.newInstance(<PolicyBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyBatchResponse) {
        if (!obj) return;

        models.PolicyBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyBatchResponse): boolean {
        Object.setPrototypeOf(obj, PolicyBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.Policy.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.Policy; };

}
